import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import styled, { css } from 'styled-components';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import TooltipButton from 'components/TooltipButton';
import Button from 'components/Button';
import { NavMenu, NavMenuButton, NavMenuList, NavMenuItem } from 'components/NavMenu';
import Flag from 'components/Flag';
import DropIndicator from 'components/DropIndicator';
import { spacing, typeScale } from 'styles/globals';
import { commonThumbnailOptions, handleRejectFiles } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var DropTarget = styled.div.withConfig({
  displayName: "ThumbnailUploader__DropTarget",
  componentId: "sc-dnxoh-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;", ""], function (p) {
  return p.$disabled ? css(["cursor:not-allowed;"]) : css(["cursor:pointer;"]);
});
var DropHint = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isDragActive';
  }
}).withConfig({
  displayName: "ThumbnailUploader__DropHint",
  componentId: "sc-dnxoh-1"
})(["display:inline-block;flex:1 1 100%;align-self:flex-end;max-width:12rem;margin-bottom:", ";padding:", " ", ";text-align:center;font-size:", ";color:white;background:rgba(0,0,0,0.75);border-radius:3rem;opacity:0;transition:all 250ms ease;", ":hover &{opacity:1;}", ""], spacing.m, spacing.xxxs, spacing.s, typeScale.xs, DropTarget, function (p) {
  return p.isDragActive && css(["opacity:1;"]);
});
var ButtonDrawer = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isDragActive';
  }
}).withConfig({
  displayName: "ThumbnailUploader__ButtonDrawer",
  componentId: "sc-dnxoh-2"
})(["position:absolute;top:", ";right:", ";transition:all 250ms ease;", ""], spacing.xs, spacing.xs, function (p) {
  return p.isDragActive && css(["opacity:0;transform:translateY(-1rem);pointer-events:none;"]);
});
function ThumbnailUploader(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var fieldId = props.id,
    _props$data = props.data,
    id = _props$data.id,
    type = _props$data.type,
    thumbnailId = _props$data.thumbnailId,
    previewThumbnail = props.previewThumbnail,
    removeThumbnail = props.removeThumbnail,
    uploadThumbnail = props.uploadThumbnail,
    isDisabled = props.isDisabled,
    _props$isMultiSelectW = props.isMultiSelectWithThumbnails,
    isMultiSelectWithThumbnails = _props$isMultiSelectW === void 0 ? false : _props$isMultiSelectW;
  var ids = useMemo(function () {
    return Array.isArray(id) ? id : [id];
  }, [id]);

  // We only have a thumbnail id here if all items use the same thumbnail
  var hasImage = isMultiSelectWithThumbnails || !!thumbnailId;
  var hasPreview = !!previewThumbnail;
  function getDragMessage(isDragAccept, isDragReject) {
    if (isDragAccept) {
      return hasImage ? t('actions_drop_image_to_replace') : t('actions_drop_image_to_upload');
    } else if (isDragReject) {
      return t('error_file_not_supported');
    } else return hasImage ? t('actions_click_or_drag_to_replace_image') : t('actions_click_or_drag_to_add_image');
  }
  function onRemoveThumbnail() {
    if (removeThumbnail && ids.length > 0) {
      removeThumbnail();
    }
  }
  var acceptFile = useCallback(function (acceptedFiles) {
    uploadThumbnail({
      ids: ids,
      type: type,
      file: acceptedFiles[0]
    });
  }, [ids, type, uploadThumbnail]);
  var rejectFile = useCallback(function (rejectedFiles) {
    handleRejectFiles(rejectedFiles);
  }, []);
  var _useDropzone = useDropzone(_objectSpread(_objectSpread({}, commonThumbnailOptions), {}, {
      onDropAccepted: acceptFile,
      onDropRejected: rejectFile,
      disabled: isDisabled
    })),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject,
    isDragAccept = _useDropzone.isDragAccept,
    open = _useDropzone.open;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DropTarget, _objectSpread(_objectSpread({
      $disabled: isDisabled
    }, getRootProps()), {}, {
      children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps({
        id: fieldId === null || fieldId === void 0 ? void 0 : fieldId.toString(),
        disabled: isDisabled
      }))), /*#__PURE__*/_jsx(DropIndicator, {
        m: "xs",
        textAlign: "center",
        fillParent: true,
        isDisabled: isDisabled,
        isDragReject: isDragReject,
        isDragActive: isDragActive,
        defaultTransparent: true
      }), !isDisabled && /*#__PURE__*/_jsx(DropHint, {
        isDragActive: isDragActive,
        children: /*#__PURE__*/_jsx(Flag, {
          token: /*#__PURE__*/_jsx(Icon, {
            name: "drag-and-drop"
          }),
          spacing: "xxxs",
          children: getDragMessage(isDragAccept, isDragReject)
        })
      })]
    })), /*#__PURE__*/_jsx(ButtonDrawer, {
      isDragActive: isDragActive,
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "xs",
        children: [!isDisabled && /*#__PURE__*/_jsx(Button, {
          variant: "shaded",
          size: "medium",
          icon: hasImage ? 'edit' : 'plus',
          onClick: open,
          children: hasImage ? t(isMultiSelectWithThumbnails ? 'actions_replace_image_plural' : 'actions_replace_image') : t('actions_add_image')
        }), hasPreview && /*#__PURE__*/_jsx(TooltipButton, {
          size: "medium",
          variant: "shaded",
          icon: "eye-open",
          title: t('actions_preview_image'),
          onClick: previewThumbnail
        }), !isDisabled && /*#__PURE__*/_jsxs(NavMenu, {
          id: "thumbnail-options",
          menuPlacement: "bottom-end",
          children: [/*#__PURE__*/_jsx(NavMenuButton, {
            as: TooltipButton,
            size: "medium",
            variant: "shaded",
            icon: "tools",
            title: t('thumbnail_image_options')
          }), /*#__PURE__*/_jsxs(NavMenuList, {
            children: [/*#__PURE__*/_jsx(NavMenuItem, {
              as: "a",
              href: "https://docs.5app.com/guides/creating-artwork",
              target: "_blank",
              children: t('actions_view_artwork_guide')
            }), hasImage && /*#__PURE__*/_jsx(NavMenuItem, {
              onClick: onRemoveThumbnail,
              children: t(isMultiSelectWithThumbnails ? 'actions_remove_image_plural' : 'actions_remove_image')
            })]
          })]
        })]
      })
    })]
  });
}
export default ThumbnailUploader;